import React, { useEffect } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@shared/ui/button";
import { useToast } from "@shared/hooks/use-toast";
import { useSopDetails } from "../../hooks";

// Import componentized parts
import SopHeader from "./component/SopHeader";
import SopInfoSection from "./component/SopInfoSection";
import SopTabsContainer from "./component/SopTabContainer";
import SopModals from "./component/SopModal";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";
import { usePageViewTimer } from "@shared/hooks/usePageViewTimer";

const SopDetailsPage = () => {
  const remoteUtilityId = getRemoteUtilityId();
  const { id } = useParams();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [searchParams, setSearchParams] = useSearchParams();

  usePageViewTimer({pageName: `Template ${id}`, extraProperties: {
    templateId: id
  }})

  // Get current tab from URL, default to "tasks"
  const currentTab = searchParams.get("tab") || "tasks";

  // Use the simplified hook that gets all data at once
  const { data, isLoading, error } = useSopDetails({
    id: id || "",
    remoteUtilityId: remoteUtilityId?.toString(),
  });

  const sopDetails = data?.result;

  // Handle tab change
  const handleTabChange = (newTab: string) => {
    setSearchParams({ tab: newTab });
  };

  // Loading state for initial page load

  // Error state
  if (error || !sopDetails) {
    return (
      <div className="flex justify-center items-center h-[calc(100vh-200px)]"></div>
    );
  }

  return (
    <div className="space-y-6 animate-fade-in">
      {/* Page Header */}
      <SopHeader
        sopDetails={sopDetails}
        onNavigateBack={() => navigate("/service-orders/wx-master")}
      />

      {/* SOP Info Section */}
      <SopInfoSection sopDetails={sopDetails} />

      {/* Tabs Section */}
      <SopTabsContainer
        currentTab={currentTab}
        onTabChange={handleTabChange}
        sopDetails={sopDetails}
      />

      {/* All Modals */}
      <SopModals />
    </div>
  );
};

export default SopDetailsPage;
